 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import LOVE_1 from '@/components/love_1'
 import UNTITLED234 from '@/components/Untitled234'
 import UNTITLED235 from '@/components/Untitled235'
 import UNTITLED250 from '@/components/Untitled250'
 import UNTITLED251 from '@/components/Untitled251'
 import UNTITLED252 from '@/components/Untitled252'
 import UNTITLED253 from '@/components/Untitled253'
 import UNTITLED254 from '@/components/Untitled254'
 import UNTITLED255 from '@/components/Untitled255'
 import UNTITLED256 from '@/components/Untitled256'
 import UNTITLED257 from '@/components/Untitled257'
 import UNTITLED258 from '@/components/Untitled258'
 import UNTITLED259 from '@/components/Untitled259'
 import UNTITLED260 from '@/components/Untitled260'
 import UNTITLED261 from '@/components/Untitled261'
 import UNTITLED262 from '@/components/Untitled262'
 import UNTITLED263 from '@/components/Untitled263'
 import UNTITLED264 from '@/components/Untitled264'
 import UNTITLED265 from '@/components/Untitled265'
 import UNTITLED266 from '@/components/Untitled266'
 import UNTITLED267 from '@/components/Untitled267'
 import UNTITLED268 from '@/components/Untitled268'
 import LOVE_2 from '@/components/love_2'
 import UNTITLED269 from '@/components/Untitled269'
 import UNTITLED270 from '@/components/Untitled270'
 import COPYRIGHT from '@/components/copyright'
 import DELPHINIUM from '@/components/delphinium'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Untitled234",
 			"name" : "Untitled234",
 			"component" : UNTITLED234
 		},
 		{
 			"path" : "/Untitled235",
 			"name" : "Untitled235",
 			"component" : UNTITLED235
 		},
 		{
 			"path" : "/Untitled250",
 			"name" : "Untitled250",
 			"component" : UNTITLED250
 		},
 		{
 			"path" : "/Untitled251",
 			"name" : "Untitled251",
 			"component" : UNTITLED251
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js